import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc, Timestamp } from "firebase/firestore";
import { storage, db } from "../firebaseConfig";

/**
 * Generate thumbnail and get video duration from video file
 */
const generateThumbnailAndDuration = (videoFile) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.src = URL.createObjectURL(videoFile);
    video.crossOrigin = "anonymous";
    video.currentTime = 1;

    video.addEventListener("loadeddata", () => {
      const canvas = document.createElement("canvas");
      canvas.width = 320;
      canvas.height = 180;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob((blob) => {
        if (blob) {
          resolve({
            thumbnailBlob: blob,
            duration: video.duration,
          });
        } else {
          reject("Failed to create thumbnail blob");
        }
      }, "image/jpeg");
    });

    video.onerror = () => reject("Video load error");
  });
};

export const uploadVideo = async ({
  selectedFile,
  pathString = "root",
  onProgress,
  onComplete,
  onError,
}) => {
  if (!selectedFile) return;

  try {
    const storageRef = ref(storage, `${pathString}/${selectedFile.name}`);
    const uploadTask = uploadBytesResumable(storageRef, selectedFile);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        if (onProgress) onProgress(progress);
      },
      (error) => {
        console.error("Upload error:", error);
        if (onError) onError(error);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        const id = Date.now().toString();

        let thumbUrl = "";
        let duration = 0;

        try {
          const { thumbnailBlob, duration: videoDuration } =
            await generateThumbnailAndDuration(selectedFile);
          duration = videoDuration;

          const thumbRef = ref(storage, `${pathString}/thumbs/${id}.jpg`);
          const thumbSnap = await uploadBytesResumable(thumbRef, thumbnailBlob);
          thumbUrl = await getDownloadURL(thumbSnap.ref);
        } catch (thumbErr) {
          console.warn("Thumbnail generation failed:", thumbErr);
        }

        await setDoc(doc(db, `videos/${pathString}/items`, id), {
          type: "video",
          name: selectedFile.name,
          url: downloadURL,
          thumbUrl,
          duration, // ✅ Save duration in seconds
          createdAt: Timestamp.now(),
        });

        if (onComplete) onComplete(downloadURL, selectedFile.name, thumbUrl);
      }
    );
  } catch (err) {
    console.error("Unexpected error during upload:", err);
    if (onError) onError(err);
  }
};
